import { render, staticRenderFns } from "./LearningSettingsDiploma.vue?vue&type=template&id=5aef4a48&scoped=true&"
import script from "./LearningSettingsDiploma.vue?vue&type=script&lang=js&"
export * from "./LearningSettingsDiploma.vue?vue&type=script&lang=js&"
import style0 from "./LearningSettingsDiploma.vue?vue&type=style&index=0&id=5aef4a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef4a48",
  null
  
)

export default component.exports